import cx from 'classnames'
import type React from 'react'

import lightOrDark from '@/utils/color/lightOrDark'
import css from './styles.module.css'

interface Props {
  title: string
  color: string
}

export const TagBadge: React.FC<Props> = ({ title, color }) => (
  <span
    className={cx(css.badge, {
      [css.darkColor]: lightOrDark(color) === 'light',
    })}
    style={{ backgroundColor: color }}
    title={title}
  >
    <span className={css.text}>{title}</span>
  </span>
)
